<template>
  <Notification
    id="idv-unavailable-toast"
    :message="IDV_UNAVAILABLE_MESSAGE"
    :trigger-notification="showToast"
    @toggle-visibility="showToast = false"
  />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Notification from '@/components/notification/Notification.vue';

defineOptions({ name: 'IdvUnavailableNotification' });

const IDV_UNAVAILABLE_PARAM = 'idv_unavailable';
const IDV_UNAVAILABLE_MESSAGE = 'ID verification unavailable, please contact support.';

const route = useRoute();
const router = useRouter();
const showToast = ref(false);

onMounted(() => {
  if (!(IDV_UNAVAILABLE_PARAM in route.query)) return;

  showToast.value = true;
  // Drop the param so a refresh or back navigation does not repeat the toast.
  const { [IDV_UNAVAILABLE_PARAM]: _removed, ...query } = route.query;
  router.replace({ query });
});
</script>
